import moment from 'moment';
import CalendarTableEvents from './CalendarTableEvents';

class CalendarTable extends CalendarTableEvents {
  _localDate = moment().clone();
  _thisDate = moment().clone().format('YYYY-MM-DD');
  _inner;

  constructor(options) {
    super(options.element)
    this.element = options.element;
    this.count = this.element.getAttribute('data-table-months') ? this.element.getAttribute('data-table-months') : (options.count ? options.count : 3);
    this._inner = this.element.querySelector('.swiper-wrapper.slider__wrapper');

    this.init()
  }

  get getElement() {
    return this.element;
  }

  init() {
    this.addMonth(this.count);
  }

  addMonth(number) {
    let count = number ? number : 1;

    for (let i = 0; i < count; i++) {
      this._localDate = this.#newMonth(this._localDate);
    }

    if (window.calendarTable.slider) {
      window.calendarTable.slider.update()
    }
  }

  #newMonth(date) {
    const tempDate = date.clone();
    let firstDay = tempDate.clone().startOf('month').startOf('week');
    let lastDay = tempDate.clone().endOf('month').endOf('week');
    let monthName = tempDate.format('MMMM');
    let day = firstDay.clone();
    let slide;
    let table;
    let mainPattern = `
            <div class="calendar-table__main">
                <div class="calendar-table__thead">
                    <div class="calendar-table__thead-col">Пон</div>
                    <div class="calendar-table__thead-col">Вто</div>
                    <div class="calendar-table__thead-col">Сре</div>
                    <div class="calendar-table__thead-col">Чет</div>
                    <div class="calendar-table__thead-col">Пят</div>
                    <div class="calendar-table__thead-col">Суб</div>
                    <div class="calendar-table__thead-col">Вос</div>
                </div>
                <div class="calendar-table__tbody"></div>
            </div>
        `;

    // Создание
    slide = document.createElement('div');
    slide.classList.add('swiper-slide', 'slider__slide');
    slide.innerHTML = mainPattern;
    slide.setAttribute('data-calendar-date', [monthName + '; ' + tempDate.format('YYYY')])
    table = slide.querySelector('.calendar-table__tbody');

    this._inner.append(slide)

    // Наполнение
    while (!day.isAfter(lastDay)) {
      let dayDate = day.clone();
      this.#newDay(table, dayDate, monthName)

      day.add(1, 'day');
    }

    return tempDate.clone().add(1, 'month');
  }

  #newDay(table, date, month) {
    let thisDate = date;
    let thisMonth = thisDate.format('MMMM');
    let number = thisDate.format('DD');
    let value = thisDate.format('YYYY-MM-DD');
    let dayPattern = `
            <div class="calendar-table__day-number">
                <span>` + number + `</span>
            </div>
            <div class="calendar-table__day-list">

            </div>
            <div class="calendar-table__day-actions">
                <button class="button calendar-table__day-add" type="button">
                    <svg class="icon button__icon">
                        <use xlink:href="#plus"></use>
                    </svg>
                </button>
            </div>
        `;

    // <button class="link calendar-table__day-link" type="button">
    //     <span>Все</span>
    // </button>

    // Создание
    let element = document.createElement('div');
    element.classList.add('calendar-table__day');
    element.setAttribute('data-calendar-date', value);
    element.innerHTML = dayPattern;

    if (thisMonth != month || thisDate.isBefore(this._thisDate)) {
      element.setAttribute('disabled', true)
    }

    if (thisDate.format('YYYY-MM-DD') == this._thisDate) {
      element.classList.add('calendar-table__day--today')
    }

    table.append(element)
  }
}

window.CalendarTable = CalendarTable;

export default CalendarTable;
